
import { Helmet } from 'react-helmet'
import SignUpCard from '../../components/SignUp/SignUpCard'
import { resetAuthError, resetAuthSuccess, resetSession } from '../../redux/auth'
import { connect } from 'react-redux'
import { RootState } from '../../redux/rootReducers'
import { Loader } from '../../components/commons'
import { useEffect } from 'react'
import AuSignUpCard from '../../components/AuSignUp/AuSignUpCard'

type AppProps={
  success:number|null;
message:string|null;
fetching:boolean;
error:string|null;
statusCode:number|null;
dispatchResetAuthError:()=> void;
dispatchResetAuthSuccess:()=> void;
dispatchResetSessionAction:()=> void;
}
const AuSignUp = ({
  success,
  message,
  fetching,
  error,
  statusCode,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetSessionAction
}:AppProps) => {

    useEffect(() => {
      dispatchResetAuthError();
      dispatchResetAuthSuccess();



    }, []);

  return (
    <div>
       <Helmet>
        <title>FINAC by Akssai ProjExel</title>
      </Helmet>
      <>
       
      </>
      <AuSignUpCard/>
     
      {fetching && <Loader />}
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  success: state.auth.success,
  message: state.auth.message,
  fetching: state.auth.fetching,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
 
});

const mapDispatchToProps = (dispatch: any) => ({
  
  dispatchResetAuthError: () => dispatch(resetAuthError()),

  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSessionAction: () => dispatch(resetSession()),

});


export default connect(mapStateToProps, mapDispatchToProps)(AuSignUp);


